import React, { useState, useRef, useEffect } from "react";
import LogoCarousel from "./components/IntegrationSupport/IntegrationSupport";
import Footer from "../../components/Footer/Footer";
import VoiceAIForm from "./CustomUsecaseForm/CustomUsecaseForm";
import Navbar from "../../components/NavigationMenu/NavBar";
import { Button, Modal } from "@mui/material";
import { Mic } from "@mui/icons-material";
import useSEO from "../../hooks/useSEO";
import {
  Tabs,
  Tab,
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { CheckCircle, ArrowForward, Send } from "@mui/icons-material";
import Vapi from "@vapi-ai/web";
import { voiceAgentService } from "../../services/VoiceAgentService";
import CalendarModal from "../../components/CalendarModal/CalendarModal";
import { ContactForm } from "../../components/ContactForm/ContactForm";

const vapi = new Vapi(process.env.REACT_APP_VAPI_PUBLIC_KEY);

const handleVoiceToggle = async (
  isActive,
  setActive,
  useCaseId = "customer-support"
) => {
  if (!isActive) {
    try {
      vapi.start(process.env.REACT_APP_VAPI_BEANBAG_ASSISTANT_ID);
      setActive(true);
      console.log("Voice interaction started successfully");
    } catch (error) {
      console.error("Error starting Vapi assistant:", error);
      alert(
        "Failed to start voice interaction. Please check your microphone permissions and try again."
      );
    }
  } else {
    try {
      vapi.stop();
      setActive(false);
      console.log("Voice interaction stopped");
    } catch (error) {
      console.error("Error stopping Vapi assistant:", error);
    }
  }
};


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}


// Google Sheets service URL - make sure this matches your deployed script

// Enhanced JSONP utility with better error handling


// Enhanced Google Sheets service


const CampaignLandingPage = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVoiceActive, setIsVoiceActive] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("+1");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [callInitiated, setCallInitiated] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [isCallActive, setIsCallActive] = useState(false);
  const [callStatus, setCallStatus] = useState("");
  const [isPhoneCallLoading, setIsPhoneCallLoading] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  // Fixed: Moved useEffect hooks inside the component
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);



  // Add Vapi widget on component mount
  useEffect(() => {
    // Create and inject the Vapi widget element
    const vapiWidget = document.createElement('vapi-widget');
    vapiWidget.setAttribute('public-key', 'f3c1c3fb-e293-441c-9b2a-3e86193aaa5d');
    vapiWidget.setAttribute('assistant-id', '8b99a85e-9bc9-4de2-a391-4f2fbc743a33');
    vapiWidget.setAttribute('mode', 'voice');
    vapiWidget.setAttribute('theme', 'dark');
    vapiWidget.setAttribute('base-bg-color', '#000000');
    vapiWidget.setAttribute('accent-color', '#de5e37');
    vapiWidget.setAttribute('cta-button-color', '#000000');
    vapiWidget.setAttribute('cta-button-text-color', '#ffffff');
    vapiWidget.setAttribute('border-radius', 'large');
    vapiWidget.setAttribute('size', 'full');
    vapiWidget.setAttribute('position', 'bottom-right');
    vapiWidget.setAttribute('title', 'TALK TO AGENT');
    vapiWidget.setAttribute('start-button-text', 'Start');
    vapiWidget.setAttribute('end-button-text', 'End Call');
    vapiWidget.setAttribute('chat-first-message', 'Hey, How can I help you today?');
    vapiWidget.setAttribute('chat-placeholder', 'Type your message...');
    vapiWidget.setAttribute('voice-show-transcript', 'true');
    vapiWidget.setAttribute('consent-required', 'true');
    vapiWidget.setAttribute('consent-title', 'Terms and conditions');
    vapiWidget.setAttribute('consent-content', 'By clicking Agree, and each time I interact with this AI agent, I consent to the recording, storage, and sharing of my communications with third-party service providers, and as otherwise described in our Terms of Service.');
    vapiWidget.setAttribute('consent-storage-key', 'vapi_widget_consent');
    
    // Add widget to body
    document.body.appendChild(vapiWidget);
    
    // Load the Vapi widget script
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/@vapi-ai/client-sdk-react/dist/embed/widget.umd.js';
    script.async = true;
    script.type = 'text/javascript';
    document.head.appendChild(script);
    
    // Cleanup function
    return () => {
      // Remove widget element
      if (document.body.contains(vapiWidget)) {
        document.body.removeChild(vapiWidget);
      }
      
      // Remove script (optional, but good practice)
      const existingScript = document.querySelector('script[src="https://unpkg.com/@vapi-ai/client-sdk-react/dist/embed/widget.umd.js"]');
      if (existingScript && existingScript.parentNode) {
        existingScript.parentNode.removeChild(existingScript);
      }
    };
  }, []);

  useEffect(() => {
    vapi.on("call-start", () => {
      setIsCallActive(true);
      setCallStatus("Voice interaction started");
    });

    vapi.on("call-end", () => {
      setIsCallActive(false);
      setCallStatus("Voice interaction ended");
      setIsVoiceActive(false);
    });

    vapi.on("error", (error) => {
      console.error("VAPI Error:", error);
      setCallStatus("Voice interaction failed");
      setIsCallActive(false);
      setIsVoiceActive(false);
    });

    return () => {
      vapi.removeAllListeners();
    };
  }, []); 

  const handlePhoneCall = async (useCaseId = "customer-support") => {
    if (!phoneNumber) {
      alert("Please enter a phone number");
      return;
    }

    setIsPhoneCallLoading(true);
    setCallInitiated(false);

    try {
      const fullPhoneNumber = `${selectedCountry}${phoneNumber}`;
      const result = await voiceAgentService.makeOutboundCall(
        fullPhoneNumber,
        useCaseId
      );

      if (result.status === "started") {
        setCallInitiated(true);
        setCallStatus(`Outbound ${useCaseId} call initiated successfully`);
      } else {
        throw new Error("Call failed to start");
      }
    } catch (error) {
      console.error("Error making outbound call:", error);
      setCallStatus("Failed to initiate outbound call");
      alert("Failed to start outbound call. Please try again.");
    } finally {
      setIsPhoneCallLoading(false);
    }
  };

  const styles = {
    body: {
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      lineHeight: "1.6",
      color: "#333",
      background: "#ffffff",
      margin: 0,
      padding: 0,
    },
    container: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "0 0px",
    },
    header: {
      position: "fixed",
      top: 0,
      width: "100%",
      background: isScrolled
        ? "rgba(255, 255, 255, 0.98)"
        : "rgba(255, 255, 255, 0.95)",
      backdropFilter: "blur(10px)",
      zIndex: 1000,
      transition: "all 0.3s ease",
      boxShadow: isScrolled ? "0 2px 20px rgba(0, 0, 0, 0.1)" : "none",
    },
    nav: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    hero: {
      padding: "120px 0 80px",
      background:
        "radial-gradient(ellipse at top, rgba(226, 107, 74, 0.05) 0%, transparent 70%)",
    },
    heroTitle: {
      fontSize: "clamp(2.5rem, 5vw, 4rem)",
      fontWeight: "700",
      marginBottom: "24px",
      background: "linear-gradient(135deg, #333,rgb(226, 104, 74))",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
      animation: "fadeInUp 1s ease-out",
    },
    heroText: {
      fontSize: "1.25rem",
      maxWidth: "800px",
      margin: "0 auto 40px",
      color: "#666",
      animation: "fadeInUp 1s ease-out 0.2s both",
    },
    formSection: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minWidth: "350px",
      background: "white",
      borderRadius: "16px",
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
      border: "1px solid rgba(0, 0, 0, 0.05)",
    },
    clientLogos: {
      padding: "60px 0",
      background: "#f8f9fa",
      overflow: "hidden",
    },
    section: {
      padding: "80px 0",
    },
    sectionAlt: {
      padding: "40px 0",
      background: "#f8f9fa",
    },
    sectionTitle: {
      fontSize: "2.5rem",
      fontWeight: "700",
      textAlign: "center",
      marginBottom: "40px",
      color: "#333",
      margin: "10px",
    },
    voiceSection: {
      padding: "80px 0",
      textAlign: "center",
    },
    voiceContent: {
      maxWidth: "600px",
      margin: "0 auto",
      padding: "0 10px",
    },
    benefitsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "20px",
      marginTop: "20px",
      marginLeft: "40px",
      marginRight: "40px",
    },
    benefit: {
      textAlign: "center",
      padding: "40px 30px",
      background: "white",
      borderRadius: "15px",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.08)",
      height: "13rem",
    },
    benefitNumber: {
      fontSize: "3rem",
      fontWeight: "700",
      color: "#ea6347",
      display: "block",
      marginBottom: "10px",
    },
    testimonial: {
      padding: "80px 0",
      textAlign: "center",
    },
    testimonialContent: {
      maxWidth: "800px",
      margin: "0 auto",
      padding: "60px 40px",
      background: "white",
      borderRadius: "20px",
      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
      position: "relative",
    },
    testimonialText: {
      fontSize: "1rem",
      lineHeight: "1.6",
      marginBottom: "1.5rem",
      fontStyle: "italic",
      color: "#333",
    },
    testimonialAuthor: {
      fontWeight: "600",
      color: "#ea6347",
    },
    security: {
      padding: "80px 0",
      background: "#f8f9fa",
      textAlign: "center",
    },
    securityBadges: {
      display: "flex",
      justifyContent: "center",
      gap: "40px",
      marginTop: "40px",
      flexWrap: "wrap",
    },
    badge: {
      padding: "15px 30px",
      background: "white",
      borderRadius: "50px",
      fontWeight: "600",
      color: "#ea6347",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
    },
    featureTitle: {
      fontSize: "1.25rem",
      fontWeight: "600",
      marginBottom: "10px",
      color: "#333",
    },
    featureText: {
      color: "#666",
    },
    testimonialCard: {
      backgroundColor: "#ffffff",
      padding: "2rem",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      minWidth: "300px",
      flex: "1",
      border: "1px solid #e0e0e0",
      transition: "transform 0.2s ease, box-shadow 0.2s ease",
      margin: "10px",
    },
    testimonialRating: {
      fontSize: "1.2rem",
      color: "#ffc107",
      marginBottom: "1rem",
    },
    testimonialsRow: {
      display: "flex",
      gap: "2rem",
      marginTop: "2rem",
      overflowX: "auto",
      padding: "1rem 0",
    },
  };

  const useCases = [
    {
      id: "sales-assistant",
      title: "Cart Recovery Agent (Shopify)",
      description:
        "Intelligent voice agents that recover abandoned carts and guide customers to complete their purchases.",
      features: [
        "60% Recovery Rate",
        "100% Automation",
        "Complete Domain Understanding",
        "Call Transcripts & metrics",
        "Easy Integrations",
        "Multilingual support",
      ],
      testUrl: "/test/sales-assistant",
      showNote: true,
    },
    {
      id: "customer-support",
      title: "AI Customer Support",
      description:
        "AI-powered voice agents that handle customer inquiries 24/7 with human-like conversations.",
      features: [
        "Select from top-notch voices",
        "Upload your own Knowledge",
        "API & MCP Integration for Real-time Query Resolution",
        "Call analytics & Recordings",
        "24/7 Availability",
        "Multi-language support",
      ],
      testUrl: "/test/customer-support",
      showNote: false,
    },
    {
      id: "technical-support",
      title: "Technical Support",
      description:
        "Specialized voice agents for technical troubleshooting and IT support.",
      features: [
        "Technical Diagnostics",
        "Step-by-step Guidance",
        "Knowledge Base Access",
        "Ticket Creation",
      ],
      testUrl: "/test/technical-support",
      showNote: false,
    },
    {
      id: "appointment-booking",
      title: "Appointment Booking",
      description:
        "Voice agents that handle appointment scheduling and calendar management.",
      features: [
        "Calendar Integration",
        "Availability Checking",
        "Reminder Notifications",
        "Rescheduling",
      ],
      testUrl: "/test/appointment-booking",
      showNote: false,
    },
  ];

  const features = [
    {
      icon: "⚡",
      title: "Efficiency",
      description: "Get results in hours, not weeks.",
    },
    {
      icon: "👤",
      title: "Personalization",
      description:
        "Engage with customers through personalized voice interactions.",
    },
    {
      icon: "📈",
      title: "Scalability",
      description: "Reach millions of users with ease.",
    },
    {
      icon: "🔒",
      title: "Security",
      description:
        "Your data is safe with us. We comply with the highest standards.",
    },
  ];

  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "CTO, TechCorp",
      content:
        "Beanbag voice agents reduced our support costs by 60% while improving customer satisfaction.",
      rating: 5,
    },
    {
      name: "Michael Chen",
      role: "Head of Operations, StartupXYZ",
      content:
        "The implementation was seamless and the results were immediate. Highly recommended!",
      rating: 5,
    },
    {
      name: "Emily Rodriguez",
      role: "Customer Success Manager, Enterprise Inc",
      content:
        "Our customers love the natural conversations. It feels like talking to a real person.",
      rating: 5,
    },
  ];

  const benefits = [
    {
      number: "3x",
      title: "Longer Responses",
      description:
        "Customers provide more detailed feedback compared to traditional methods.",
    },
    {
      number: "<24h",
      title: "Fast Results",
      description: "Get actionable insights within hours.",
    },
    {
      number: "+30M",
      title: "Possible Respondents",
      description: "Reach a broad audience with ease.",
    },
  ];

  useSEO({
    title: `Voice - Beanbag AI`,
    description: "Voice Description",
    canonical: "https://www.beanbag.ai/voice",
    keywords:
      "AI voice agents, voice AI, customer support automation, voice technology",
    ogTitle: "Voice AI Solutions - Beanbag AI",
    ogDescription: "Unlock Deeper Customer Insights with Voice AI",
    ogImage: "https://www.beanbag.ai/images/beanbag-social-card.jpg",
    ogUrl: "https://www.beanbag.ai/voice",
    ogType: "website",
    twitterCard: "summary_large_image",
    twitterSite: "@BeanbagAI",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Beanbag AI",
      url: "https://www.beanbag.ai",
      logo: "https://www.beanbag.ai/logo192.png",
      description:
        "Beanbag AI provides intelligent voice automation solutions to enhance customer interactions.",
    },
  });

  const renderPhoneCallSection = (useCaseId) => (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "8px",
          width: "100%",
          maxWidth: "400px",
        }}
      >
        <FormControl sx={{ minWidth: "80px" }}>
          <Select
            value={selectedCountry}
            onChange={(e) => setSelectedCountry(e.target.value)}
            size="small"
          >
            <MenuItem value="+1">🇺🇸 +1</MenuItem>
            <MenuItem value="+44">🇬🇧 +44</MenuItem>
            <MenuItem value="+91">🇮🇳 +91</MenuItem>
            <MenuItem value="+966">🇸🇦 +966</MenuItem>
            <MenuItem value="+86">🇨🇳 +86</MenuItem>
            <MenuItem value="+49">🇩🇪 +49</MenuItem>
            <MenuItem value="+33">🇫🇷 +33</MenuItem>
            <MenuItem value="+81">🇯🇵 +81</MenuItem>
            <MenuItem value="+61">🇦🇺 +61</MenuItem>
            <MenuItem value="+55">🇧🇷 +55</MenuItem>
            <MenuItem value="+7">🇷🇺 +7</MenuItem>
          </Select>
        </FormControl>
        <TextField
          type="tel"
          placeholder="Enter phone number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          size="small"
          sx={{ flexGrow: 1 }}
        />
      </Box>

      <Button
        variant="contained"
        size="large"
        endIcon={<ArrowForward />}
        onClick={() => handlePhoneCall(useCaseId)}
        disabled={isPhoneCallLoading || !phoneNumber}
        sx={{
          backgroundColor: "#ea6347",
          "&:hover": { backgroundColor: "#d55640" },
          padding: "12px 24px",
          width: "100%",
          maxWidth: "400px",
        }}
      >
        {isPhoneCallLoading ? "Calling..." : "Talk Now"}
      </Button>

      {callInitiated && (
        <Typography
          sx={{
            color: "#4caf50",
            fontSize: "0.875rem",
            textAlign: "center",
            marginTop: "8px",
            fontWeight: "500",
          }}
        >
          You should be receiving a call right now.
        </Typography>
      )}

      <Typography
        sx={{
          color: "#666",
          fontSize: "0.875rem",
          textAlign: "center",
          maxWidth: "400px",
        }}
      >
        Don't wait for the demo. Just enter your number and receive a call from
        our agent now.
      </Typography>
    </Box>
  );

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Add Vapi widget on component mount
  // useEffect(() => {
  //   // Create and inject the Vapi widget element
  //   const vapiWidget = document.createElement('vapi-widget');
  //   vapiWidget.setAttribute('public-key', 'f3c1c3fb-e293-441c-9b2a-3e86193aaa5d');
  //   vapiWidget.setAttribute('assistant-id', '4bcae9eb-107c-4d62-9221-92c6404f6116');
  //   vapiWidget.setAttribute('mode', 'voice');
  //   vapiWidget.setAttribute('theme', 'dark');
  //   vapiWidget.setAttribute('base-bg-color', '#000000');
  //   vapiWidget.setAttribute('accent-color', '#682a8d');
  //   vapiWidget.setAttribute('cta-button-color', '#000000');
  //   vapiWidget.setAttribute('cta-button-text-color', '#ffffff');
  //   vapiWidget.setAttribute('border-radius', 'large');
  //   vapiWidget.setAttribute('size', 'full');
  //   vapiWidget.setAttribute('position', 'bottom-right');
  //   vapiWidget.setAttribute('title', 'READY TO TAKE YOUR ORDER');
  //   vapiWidget.setAttribute('start-button-text', 'Start');
  //   vapiWidget.setAttribute('end-button-text', 'End Call');
  //   vapiWidget.setAttribute('chat-first-message', 'Hey, How can I help you today?');
  //   vapiWidget.setAttribute('chat-placeholder', 'Type your message...');
  //   vapiWidget.setAttribute('voice-show-transcript', 'true');
  //   vapiWidget.setAttribute('consent-required', 'true');
  //   vapiWidget.setAttribute('consent-title', 'Terms and conditions');
  //   vapiWidget.setAttribute('consent-content', 'By clicking Agree, and each time I interact with this AI agent, I consent to the recording, storage, and sharing of my communications with third-party service providers, and as otherwise described in our Terms of Service.');
  //   vapiWidget.setAttribute('consent-storage-key', 'vapi_widget_consent');
    
  //   // Add widget to body
  //   document.body.appendChild(vapiWidget);
    
  //   // Load the Vapi widget script
  //   const script = document.createElement('script');
  //   script.src = 'https://unpkg.com/@vapi-ai/client-sdk-react/dist/embed/widget.umd.js';
  //   script.async = true;
  //   script.type = 'text/javascript';
  //   document.head.appendChild(script);
    
  //   // Cleanup function
  //   return () => {
  //     // Remove widget element
  //     if (document.body.contains(vapiWidget)) {
  //       document.body.removeChild(vapiWidget);
  //     }
      
  //     // Remove script (optional, but good practice)
  //     const existingScript = document.querySelector('script[src="https://unpkg.com/@vapi-ai/client-sdk-react/dist/embed/widget.umd.js"]');
  //     if (existingScript && existingScript.parentNode) {
  //       existingScript.parentNode.removeChild(existingScript);
  //     }
  //   };
  // }, []);

  return (
    <div style={styles.body}>
      <style>
        {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
              box-shadow: 0 4px 20px rgba(226, 107, 74, 0.3);
            }
            50% {
              transform: scale(1.05);
              box-shadow: 0 8px 40px rgba(226, 107, 74, 0.5);
            }
          }

          @keyframes ping {
            0% {
              transform: translate(-50%, -50%) scale(1);
              opacity: 1;
            }
            75%, 100% {
              transform: translate(-50%, -50%) scale(2);
              opacity: 0;
            }
          }

          @media (max-width: 768px) {
            .section-title {
              font-size: 2rem !important;
            }
            .hero-title {
              font-size: 2.5rem !important;
            }
            .hero-text {
              font-size: 1.1rem !important;
            }
            .benefits-grid {
              grid-template-columns: 1fr !important;
            }
            .hero-container {
              flex-direction: column !important;
              align-items: center;
              gap: 2rem;
            }
            .hero-content {
              max-width: 100% !important;
              text-align: center;
            }
            .form-section {
              min-width: unset !important;
            }
          }
        `}
      </style>

      <header style={styles.header}>
        <div style={styles.container}>
          <nav style={styles.nav}>
            <Navbar />
          </nav>
        </div>
      </header>

      <main>
        <section style={styles.hero}>
          <div
            style={{
              ...styles.container,
              display: "flex",
              alignItems: "center",
              justifyContent: "left",
              gap: "12rem",
            }}
            className="hero-container"
          >
            <div
              style={{ flex: 1, maxWidth: "600px" }}
              className="hero-content"
            >
              <h1 style={styles.heroTitle} className="hero-title">
                Create AI Voice Agent for Your Brand in 5 Mins!
              </h1>
              <p style={styles.heroText} className="hero-text">
                It is more than just an AI voice agent—it replaces traditional
                methods with intelligent, voice-moderated interactions. Our AI
                voice agent conducts personalized conversations at scale,
                providing you with deep insights and actionable data—fast.
              </p>
              <Button
                variant="text"
                onClick={handleOpenModal}
                sx={{
                  textDecoration: "underline",
                  textTransform: "none",
                  fontSize: { xs: "16px", sm: "18px", md: "20px" },
                  fontWeight: 500,
                  p: "8px 16px",
                  borderRadius: "8px",
                  position: "relative",
                  transition: "all 0.3s ease",
                  backgroundColor: "rgba(234, 99, 71, 0.1)",
                  color: "#ea6347",
                  textDecoration: "none",
                  "&:hover": {
                    transform: "translateY(-2px)",
                  },
                  "&:active": {
                    transform: "translateY(0px)",
                  },
                }}
              >
                Book a Demo
              </Button>
            </div>

            <div style={styles.formSection} className="form-section">
              <ContactForm />
            </div>
          </div>
        </section>

        <section style={styles.clientLogos}>
          <LogoCarousel />
        </section>

        <section
          id="use-cases"
          style={{ padding: "80px 0", backgroundColor: "white" }}
        >
          <div style={styles.container}>
            <div style={{ textAlign: "center", marginBottom: "64px" }}>
              <Typography
                variant="h4"
                component="h3"
                sx={{
                  marginBottom: "16px",
                  color: "#333",
                  fontWeight: "700",
                }}
              >
                Voice Agent Use Cases
              </Typography>
              <p
                style={{
                  fontSize: "1.25rem",
                  color: "#666",
                  maxWidth: "800px",
                  margin: "0 auto",
                }}
              >
                Discover how our voice agents can transform different aspects of
                your business
              </p>
            </div>

            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  backgroundColor: "white",
                  borderRadius: "8px 8px 0 0",
                }}
              >
                <Tabs
                  value={tabValue}
                  onChange={(event, newValue) => setTabValue(newValue)}
                  variant="fullWidth"
                  sx={{
                    "& .MuiTab-root": {
                      textTransform: "none",
                      fontWeight: 500,
                      fontSize: "0.875rem",
                      minHeight: "48px",
                      padding: "12px 8px",
                      color: "#666",
                      transition: "all 0.2s ease-in-out",
                      flex: 1,
                      maxWidth: "none",
                      "&:hover": {
                        color: "#ea6347",
                        backgroundColor: "rgba(234, 99, 71, 0.04)",
                      },
                    },
                    "& .MuiTab-root.Mui-selected": {
                      color: "#ea6347",
                      fontWeight: 600,
                      backgroundColor: "rgba(234, 99, 71, 0.08)",
                    },
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#ea6347",
                      height: "3px",
                      borderRadius: "2px 2px 0 0",
                    },
                    "& .MuiTabs-flexContainer": {
                      width: "100%",
                    },
                  }}
                >
                  {useCases.map((useCase, index) => (
                    <Tab key={useCase.id} label={useCase.title} />
                  ))}
                </Tabs>
              </Box>

              {useCases.map((useCase, index) => (
                <TabPanel key={useCase.id} value={tabValue} index={index}>
                  <Card
                    sx={{
                      backgroundColor: "white",
                      boxShadow: "0 3px 12px rgba(0, 0, 0, 0.06)",
                      borderRadius: "0 0 8px 8px",
                    }}
                  >
                    <CardContent sx={{ padding: "32px" }}>
                      <Typography
                        variant="h4"
                        component="h3"
                        sx={{
                          marginBottom: "16px",
                          color: "#333",
                          fontWeight: "700",
                        }}
                      >
                        {useCase.title}
                      </Typography>

                      <Typography
                        variant="h6"
                        component="p"
                        sx={{
                          marginBottom: "24px",
                          color: "#666",
                          fontSize: "1.125rem",
                        }}
                      >
                        {useCase.description}
                      </Typography>

                      {useCase.showNote && (
                        <Box
                          sx={{
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e9ecef",
                            borderRadius: "8px",
                            padding: "16px 20px",
                            marginBottom: "32px",
                            position: "relative",
                          }}
                        >
                          <Typography
                            variant="body2"
                            component="p"
                            sx={{
                              color: "#495057",
                              fontSize: "0.95rem",
                              lineHeight: "1.5",
                              margin: 0,
                              fontWeight: "500",
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: "#6c757d",
                                fontWeight: "600",
                                marginRight: "8px",
                              }}
                            >
                              Note:
                            </Box>
                            This Shopify Cart Recovery agent is built for{" "}
                            <Box
                              component="a"
                              href="https://redlighttherapyhome.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                              sx={{
                                color: "#ea6347",
                                textDecoration: "none",
                                fontWeight: "600",
                                transition: "all 0.2s ease",
                                "&:hover": {
                                  color: "#d55640",
                                  textDecoration: "underline",
                                },
                              }}
                            >
                              Red Light Therapy Home
                            </Box>{" "}
                            company.
                          </Typography>
                        </Box>
                      )}

                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                          gap: "32px",
                        }}
                      >
                        <div>
                          <Typography
                            variant="h6"
                            component="h4"
                            sx={{
                              marginBottom: "16px",
                              color: "#333",
                              fontWeight: "600",
                            }}
                          >
                            Key Features:
                          </Typography>
                          <List>
                            {useCase.features.map((feature, featureIndex) => (
                              <ListItem
                                key={featureIndex}
                                sx={{ padding: "4px 0" }}
                              >
                                <ListItemIcon sx={{ minWidth: "32px" }}>
                                  <CheckCircle
                                    sx={{
                                      color: "#ea6347",
                                      fontSize: "20px",
                                    }}
                                  />
                                </ListItemIcon>
                                <ListItemText
                                  primary={feature}
                                  sx={{ color: "#666" }}
                                />
                              </ListItem>
                            ))}
                          </List>
                        </div>

                        {renderPhoneCallSection(useCase.id)}
                      </Box>
                    </CardContent>
                  </Card>
                </TabPanel>
              ))}
            </Box>
          </div>
        </section>

        <section style={styles.sectionAlt}>
          <div style={styles.container}>
            <div
              style={{
                textAlign: "center",
                marginBottom: "64px",
                padding: "10px",
              }}
            >
              <h2 style={styles.sectionTitle} className="section-title">
                Why Choose Beanbag AI?
              </h2>
              <p
                style={{
                  fontSize: "1.25rem",
                  color: "#666",
                  maxWidth: "800px",
                  margin: "0 auto",
                }}
              >
                Built for enterprise scale with cutting-edge AI technology
              </p>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "24px",
                marginTop: "40px",
              }}
            >
              {features.map((feature, index) => (
                <Card
                  key={index}
                  sx={{
                    margin: "10px",
                    backgroundColor: "white",
                    border: "1px solid rgba(0, 0, 0, 0.1)",
                    borderRadius: "12px",
                    boxShadow: "0 3px 12px rgba(0, 0, 0, 0.06)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      borderColor: "rgba(234, 99, 71, 0.5)",
                      boxShadow: "0 8px 25px rgba(234, 99, 71, 0.15)",
                      transform: "translateY(-4px)",
                    },
                  }}
                >
                  <CardContent sx={{ padding: "24px" }}>
                    <div
                      style={{
                        width: "48px",
                        height: "48px",
                        background: "linear-gradient(135deg, #f09481, #ea6347)",
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "16px",
                      }}
                    >
                      <div style={{ color: "white", fontSize: "24px" }}>
                        {feature.icon}
                      </div>
                    </div>
                    <Typography
                      variant="h6"
                      component="h3"
                      sx={{
                        fontSize: "1.25rem",
                        fontWeight: "600",
                        marginBottom: "8px",
                        color: "#333",
                      }}
                    >
                      {feature.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#666",
                        lineHeight: "1.6",
                      }}
                    >
                      {feature.description}
                    </Typography>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>

        <section style={styles.voiceSection}>
          <div style={styles.container}>
            <div style={styles.voiceContent}>
              <h2 style={styles.sectionTitle} className="section-title">
                More Than Just Words
              </h2>
              <p style={{ ...styles.heroText, animation: "none" }}>
                Voice interactions capture the nuances of human
                communication—tone, inflection, and emotion. Beanbag AI goes
                beyond text to uncover deeper user sentiment, providing you with
                richer insights.
              </p>
            </div>
          </div>
        </section>

        <section style={styles.sectionAlt}>
          <div style={styles.container}>
            <h2 style={styles.sectionTitle} className="section-title">
              Key Benefits
            </h2>
            <div style={styles.benefitsGrid} className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} style={styles.benefit}>
                  <span style={styles.benefitNumber}>{benefit.number}</span>
                  <h3 style={styles.featureTitle}>{benefit.title}</h3>
                  <p style={styles.featureText}>{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section style={styles.testimonial}>
          <div style={styles.container}>
            <h2 style={styles.sectionTitle} className="section-title">
              What Our Customers Say
            </h2>
            <div style={styles.testimonialsRow}>
              {testimonials.map((testimonial, index) => (
                <div key={index} style={styles.testimonialCard}>
                  <div style={styles.testimonialRating}>
                    {"★".repeat(testimonial.rating)}
                  </div>
                  <p style={styles.testimonialText}>"{testimonial.content}"</p>
                  <p style={styles.testimonialAuthor}>
                    — {testimonial.name}, {testimonial.role}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section style={styles.security}>
          <div style={styles.container}>
            <h2 style={styles.sectionTitle} className="section-title">
              Your Data is Safe with Us
            </h2>
            <p style={styles.featureText}>
              We prioritize your data security. Beanbag AI is compliant with
              industry standards.
            </p>
            <div style={styles.securityBadges}>
              <div style={styles.badge}>SOC 2 Type II</div>
              <div style={styles.badge}>GDPR Compliant</div>
            </div>
          </div>
        </section>
      </main>

      <div id="contact" style={{ padding: "20px" }}>
        <VoiceAIForm />
        <Footer />
      </div>

      <CalendarModal open={modalOpen} handleClose={handleCloseModal} />
    </div>
  );
};

export default CampaignLandingPage;
